import React, { useEffect, useState } from "react";
import {
  Layout,
  Button,
  Avatar,
  Drawer,
  Space,
  Typography,
  Input,
  Upload,
  message,
  Grid,
} from "antd";
import {
  MenuOutlined,
  UserOutlined,
  EditOutlined,
  BankOutlined,
  UploadOutlined,
  LockOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { useAuth } from "../context/Authcontext";
import { updateUserApi, updateUserPassword } from "../services/users";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;
const { Text, Title } = Typography;
const { useBreakpoint } = Grid;

const AppHeader = ({ onMenuClick }) => {
  const screens = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [profileDrawerOpen, setProfileDrawerOpen] = useState(false);
  const [nestedDrawer, setNestedDrawer] = useState(null);
  const { getItemFromStorage, logout } = useAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    email: "",
    avatar: "",
  });

  const getUserProfile = async () => {
    let userRes = getItemFromStorage("user");
    setUser({ ...user, ...userRes });
  };

  useEffect(() => {
    getUserProfile();
  }, []);

  const handleUpload = (info) => {
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const [changePassword, setChangePassword] = useState({ old: "", new: "" });
  const [bankDetails, setBankDetails] = useState({});

  const handlePassword = async () => {
    let token = localStorage.getItem("token");
    let res = await updateUserPassword(changePassword, token);
    if (res?.message) toast.success(res?.message);
    else toast.error(res?.error?.message || "something went wrong!");
  };

  const handleBankUpdate = async () => {
    try {
      if (!bankDetails?.txnPassword)
        return toast.error("Transaction password is mandatory!");

      if (
        !bankDetails?.ifscCode &&
        !bankDetails?.acNumber &&
        !bankDetails?.acHolderName
      ) {
        return toast.error("Please fill at least one field to update.");
      }
      let res = await updateUserApi(bankDetails);

      if (res?.message) return toast.success(res?.message);
    } catch (error) {
      toast.error(error?.response?.data?.message || "something went wrong!");
    }
  };

  return (
    <>
      <Header
        style={{
          background: "#fff",
          padding: "0 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* Left: mobile menu button + logo */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {!screens.md && (
            <Button icon={<MenuOutlined />} type="text" onClick={onMenuClick} />
          )}
          <img
            src="/dashlogo.jpeg"
            alt="Logo"
            style={{
              height: 52,
              width: 52,
              objectFit: "cover",
              borderRadius: "50%",
              border: "2px solid #e0e0e0",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            }}
          />
        </div>

        {/* Right: user name and email */}
        <Space
          style={{ cursor: "pointer" }}
          onClick={() => setProfileDrawerOpen(true)}
        >
          <div style={{ lineHeight: 1, textAlign: "right" }}>
            <Text strong>{user.name}</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              {user.email}
            </Text>
          </div>
        </Space>
      </Header>

      {/* Profile Drawer */}
      <Drawer
        title="Profile Options"
        placement="right"
        onClose={() => setProfileDrawerOpen(false)}
        open={profileDrawerOpen}
      >
        <Space direction="vertical" align="center" style={{ width: "100%" }}>
          <Avatar size={80} src={user.avatar} icon={<UserOutlined />} />
          <Text strong>{user.name}</Text>
          <Text type="secondary">{user.email}</Text>
        </Space>
        <Space direction="vertical" style={{ width: "100%" }}>
          {/* <Button
            icon={<EditOutlined />}
            block
            onClick={() => setNestedDrawer("edit")}
          >
            Edit Profile
          </Button>
          <Button
            icon={<LockOutlined />}
            block
            onClick={() => setNestedDrawer("change")}
          >
            Change Password
          </Button>
          <Button
            icon={<BankOutlined />}
            block
            onClick={() => setNestedDrawer("bank")}
          >
            Bank Details
          </Button>
          <Button
            icon={<UploadOutlined />}
            block
            onClick={() => setNestedDrawer("docs")}
          >
            Upload Documents
          </Button> */}

          <Button
            icon={<LogoutOutlined />}
            block
            onClick={() => {
              if (logout()) return navigate("/login");
            }}
          >
            Logout
          </Button>
        </Space>
      </Drawer>

      {/* Nested Drawers */}
      <Drawer
        title="Edit Profile"
        placement="right"
        width={400}
        open={nestedDrawer === "edit"}
        onClose={() => setNestedDrawer(null)}
      >
        <Input placeholder="Address" style={{ marginBottom: 16 }} />
        <Input placeholder="Mobile" style={{ marginBottom: 16 }} />
        <Button type="primary" block>
          Save
        </Button>
      </Drawer>

      <Drawer
        title="Change Password"
        placement="right"
        width={400}
        open={nestedDrawer === "change"}
        onClose={() => setNestedDrawer(null)}
      >
        <Input
          placeholder="Old password"
          style={{ marginBottom: 16 }}
          onChange={(e) =>
            setChangePassword({ ...changePassword, old: e.target.value })
          }
        />
        <Input
          placeholder="New password"
          style={{ marginBottom: 16 }}
          onChange={(e) =>
            setChangePassword({ ...changePassword, new: e.target.value })
          }
        />
        <Button type="primary" block onClick={handlePassword}>
          Save
        </Button>
      </Drawer>

      <Drawer
        title="Bank Details"
        placement="right"
        width={400}
        open={nestedDrawer === "bank"}
        onClose={() => setNestedDrawer(null)}
      >
        <Input
          placeholder="IFSC Code"
          style={{ marginBottom: 16 }}
          onChange={(e) =>
            setBankDetails({ ...bankDetails, ifscCode: e.target.value })
          }
        />
        <Input
          placeholder="Account Number"
          style={{ marginBottom: 16 }}
          onChange={(e) =>
            setBankDetails({ ...bankDetails, acNumber: e.target.value })
          }
        />
        <Input
          placeholder="Account Holder Name"
          style={{ marginBottom: 16 }}
          onChange={(e) =>
            setBankDetails({ ...bankDetails, acHolderName: e.target.value })
          }
        />
        <Input
          placeholder="Transaction Password (required)"
          style={{ marginBottom: 16 }}
          onChange={(e) =>
            setBankDetails({ ...bankDetails, txnPassword: e.target.value })
          }
        />
        <Button type="primary" block onClick={handleBankUpdate}>
          Save Bank Info
        </Button>
      </Drawer>

      <Drawer
        title="Upload Documents"
        placement="right"
        width={400}
        open={nestedDrawer === "docs"}
        onClose={() => setNestedDrawer(null)}
      >
        <Title level={5}>PAN Card</Title>
        <Upload
          name="pan"
          action="/upload"
          onChange={handleUpload}
          listType="picture"
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Upload PAN</Button>
        </Upload>

        <Title level={5} style={{ marginTop: 24 }}>
          Aadhar Card
        </Title>
        <Upload
          name="aadhar"
          action="/upload"
          onChange={handleUpload}
          listType="picture"
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Upload Aadhar</Button>
        </Upload>

        <Title level={5} style={{ marginTop: 24 }}>
          Voter ID
        </Title>
        <Upload
          name="voter"
          action="/upload"
          onChange={handleUpload}
          listType="picture"
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Upload Voter ID</Button>
        </Upload>
      </Drawer>
    </>
  );
};

export default AppHeader;
